import { useRef, useState } from 'react'
import {
  Navigate,
  useNavigate,
} from 'react-router-dom/dist/umd/react-router-dom.development'
import useAuthActions from '../hooks/useAuthActions'
import { toastSuccess } from '../../helper'
import { FaSpinner } from 'react-icons/fa'
import { useAuthContext } from '../context/auth/AuthProvider'

export default function LoginPage() {
  const navigate = useNavigate()

  const { authState } = useAuthContext()

  const { login } = useAuthActions()

  const emailRef = useRef(null)
  const passwordRef = useRef(null)

  const [isLoading, setIsLoading] = useState(false)

  // Functions
  async function handleOnSubmitLoginForm(event) {
    event.preventDefault()
    setIsLoading(true)
    const payload = {
      email: emailRef.current.value,
      password: passwordRef.current.value,
    }
    const message = await login(payload)
    if (message) {
      toastSuccess(message)
    }
    setIsLoading(false)
  }

  if (authState.currentUser !== null) {
    return (
      <Navigate
        to={`/`}
        replace={true}
      />
    )
  }

  return (
    <div className="bg-light flex h-screen w-full">
      <div className="relative z-10 flex h-full w-full border-muted-700 bg-white md:w-1/2 md:border-l-2">
        <div className="m-auto flex w-full flex-col gap-8 px-16 lg:w-2/3">
          <div className="flex items-center justify-center">
            <img
              src="/assets/logos/app_logo.svg"
              alt="apfm logo"
              width={128}
            />
          </div>

          <form
            onSubmit={handleOnSubmitLoginForm}
            className="flex flex-col gap-4"
          >
            <div className="flex flex-col gap-1">
              <label
                className="font-bold"
                htmlFor="ID_EMAIL"
              >
                البريد الإلكتروني <span className="text-danger">*</span>
              </label>
              <input
                ref={emailRef}
                name="email"
                id="ID_EMAIL"
                type="email"
                className="border-2 border-muted-600 px-5 py-3 outline-none"
              />
            </div>
            <div className="flex flex-col gap-1">
              <label
                className="font-bold"
                htmlFor="ID_PASSWORD"
              >
                كلمة المرور <span className="text-danger">*</span>
              </label>
              <input
                ref={passwordRef}
                name="password"
                id="ID_PASSWORD"
                type="password"
                className="border-2 border-muted-600 px-5 py-3 outline-none"
              />
            </div>
            <div></div>
            <button
              type="submit"
              disabled={isLoading}
              className="flex w-full items-center justify-center gap-2 border-2 border-accent-600 bg-accent-600 px-6 py-3 font-bold text-white outline-none hover:border-primary-600 hover:bg-primary-600 disabled:cursor-not-allowed disabled:border-muted-500 disabled:bg-muted-300 disabled:text-primary-600"
            >
              {isLoading ? (
                <>
                  <FaSpinner
                    size={16}
                    className="animate-spin"
                  />
                  <span>جاري تسجيل الدخول...</span>
                </>
              ) : (
                <span>تسجيل الدخول</span>
              )}
            </button>
          </form>
        </div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 top-0">
        <img
          src="/assets/login-background.png"
          alt="login background"
          className="h-full w-full object-cover"
        />
      </div>
      <div className="absolute bottom-0 left-0 right-0 top-0 bg-white/50"></div>
    </div>
  )
}
